import Headroom from 'headroom.js';

// grab an element
var header = document.querySelector('#main-header');

// construct an instance of Headroom, passing the element
var headroom  = new Headroom(header, {
    tolerance: {
        up: 0,
        down: 40,
    },
    offset: 40,
});

// initialise
headroom.init();

// var oldY = 0;
// $('.section:not(:first-child)').on('mousemove', function(e){

//     console.log(e.pageY);

//     if (e.pageY < oldY ) {
//         headroom.pin();
//     } else {
//         headroom.unpin();
//     }

//     oldY = e.pageY;

// });
